import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonDialogSettings } from '../common-dialog-settings.interface';

@Component({
    selector: 'app-error-dialog',
    templateUrl: './error-dialog.component.html',
    standalone: false,
})
export class ErrorDialogComponent implements OnInit {
    public constructor(
        public dialogRef: MatDialogRef<ErrorDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public settings: CommonDialogSettings
    ) {}

    public ngOnInit(): void {}

    public onAceptar(): void {
        this.dialogRef.close();

        if (this.settings.onAceptar) {
            this.settings.onAceptar(true);
        }
    }
}
